import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import FlexBox from 'components/common/FlexBox';

const CompetenceOrderItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/competenceOrders/${data.competenceOrderId}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell>{data.approvalTypeName}</TableCell>
      <TableCell>{data.statusName}</TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton type='edit' size='small' variant='text' color='primary' tooltip={t('Edit')} onClick={handleEdit} />
          <IconButton
            type='delete'
            size='small'
            variant='text'
            color='primary'
            tooltip={t('Delete')}
            onClick={() => onDelete(data.competenceOrderId)}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

CompetenceOrderItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default CompetenceOrderItem;
